import { Controller } from "@hotwired/stimulus";

// Enter moves to the next pupil, as on paper; the form is saved by its button.
export default class extends Controller {
  static targets = ["score"];

  next(event) {
    if (event.key !== "Enter") return;

    event.preventDefault();
    const index = this.scoreTargets.indexOf(event.target);
    const following = this.scoreTargets[index + 1];
    if (following) following.focus();
  }
}
